/* build/tpl */
import deps from './deps/forEachDeep.js';
import getForEachDeep from './getForEachDeep.js';
export default getForEachDeep(deps);
